<table class="tablesaw table m-b-0" data-tablesaw-mode="swipe" data-tablesaw-sortable>
<table class="tablesaw table m-b-0" data-tablesaw-mode="swipe" style="table-layout: fixed;">
	<thead>
		<tr>
			{{#each headings}}
				<th>{{TR this}}</th>
			{{/each}}
		</tr>
	</thead>
	<tbody>
		{{#each rows}}
			<tr>
				{{#each this}}
					<td class="table-cell-sm">
						{{#if special}}
							{{{COLUMN_DATA device id displayMethod}}}
						{{else}}
							{{TR this}}
						{{/if}}
					</td>
				{{/each}}
			</tr>
		{{/each}}
	</tbody>
</table>
{{#if footer}}
	<div class="m-t-20" style="display: flex; justify-content:center;">
		<span>{{footer}}</span>
	</div>
{{/if}}
